export const KingKongBurying = {
  cid: 'c_sailor_c_u5khge1d',
  cardMC: 'b_sailor_c_lzmxln6l_mc',
  cardMV: 'b_sailor_c_lzmxln6l_mv',
  searchMV: 'b_sailor_c_qzsi42ei_mv',
  searchMC: 'b_sailor_c_qzsi42ei_mc',
  kingkongMV: 'b_sailor_c_to51typd_mv',
  kingkongItemMV: 'b_sailor_c_ry68lirv_mv',
  kingkongItemMC: 'b_sailor_c_ry68lirv_mc',
  smallPicCard: {
    MC: 'b_sailor_c_20u5x6mu_mc',
    MV: 'b_sailor_c_20u5x6mu_mv'
  },
  smallPicCardRecommandItem: {
    MC: 'b_sailor_c_n7vcwalw_mc',
    MV: 'b_sailor_c_n7vcwalw_mv'
  },
  subKingkongItemMV: 'b_sailor_c_2vzcvcnw_mv', // 子金刚曝光
  subKingkongItemMC: 'b_sailor_c_2vzcvcnw_mc' // 子金刚点击
};
const shopActivity = {
  fullReduction: 2,
  deliveryActivity: 21,
  fullDiscountActivity: 3,
  promoDishes: 18,
};
// 灵犀埋点上报参数处理
export const handleLXParam = (data: any, shop_index: number, bizTraceId: string) => {
  // 满减活动id
  const full_reduction_activity_id = data?.shopActivityList?.find((item: any) => item.activityType === shopActivity.fullReduction)?.actId || '';
  // 配送费活动id
  const delivery_activity_id = data?.shopActivityList?.find((item: any) => item.activityType === shopActivity.deliveryActivity)?.actId || '';
  // 满折活动id
  const full_discount_activity_id = data?.shopActivityList?.find((item: any) => item.activityType === shopActivity.fullDiscountActivity)?.actId || '';
  // 折扣菜 id

  const promo_dishes = data?.shopActivityList?.find((item: any) => item.activityType === shopActivity.promoDishes)?.activityShowInfo || '';

  let recommended_type = '';
  if (data.recommendData != null && data.recommendData[0] != null) {
    recommended_type = data.recommendData[0]?.type ? data.recommendData[0]?.type : '';
  }
  const recommended_reason = '';
  if (data.recommendData != null && data.recommendData[0] != null) {
    recommended_type = data.recommendData[0]?.text ? data.recommendData[0]?.text : '';
  }

  // 配送费原价
  const origin_delivery_price = data?.deliveryFee?.displayText || '';

  const logData = data?.logData || {};

  return {
    average_price: data?.avgCostPrice?.displayText || '',
    shop_id: data?.shopId,
    shop_type: data?.shopCategoryId || '',
    shop_distance: data?.distance?.desc || '',
    delivery_time: data?.deliveryTimeDesc || '',
    delivery_price: data?.finalDeliveryFeeInfo?.price?.displayText || data?.deliveryFee?.displayText || '',
    currency_type: data?.deliveryFee?.currency || data?.avgCostPrice?.currency || '',
    picture_url: data?.shopMainPicUrl || '',
    biz_trace_id: bizTraceId,
    full_discount_activity_id,
    delivery_activity_id,
    full_reduction_activity_id,
    shop_index,
    min_price: data?.minCostPrice?.displayAmount ?? '',
    promo_dishes,
    recommended_reason,
    recommended_type,
    shop_rating: data?.shopScoreInfo?.score || '-999',
    origin_delivery_price,
    ...logData,
  };
};

export const landingPageMc = (bid = '', params = {}) => {
  const Statistics = Mach.requireModule('Statistics');
  const cid = KingKongBurying.cid;
  Statistics.setTag && Statistics.setTag('sailor_c', {
    [cid]: {
      ...params,
      bid,
    },
  });
  Statistics.click(cid, bid, params);
};
export const landingPageMv = (bid = '', params = {},) => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.view(KingKongBurying.cid, bid, params);
};
export const landingPagePv = () => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.pv(KingKongBurying.cid, {});
};
